// Shared constants for the Parts & Inventory module

export const PART_STATUS = {
  in_stock: { label: "In Stock", color: "text-green-700", bg: "bg-green-100", dot: "bg-green-500" },
  low_stock: { label: "Low Stock", color: "text-amber-700", bg: "bg-amber-100", dot: "bg-amber-500" },
  out_of_stock: { label: "Out of Stock", color: "text-red-700", bg: "bg-red-100", dot: "bg-red-500" },
  ordered: { label: "Ordered", color: "text-blue-700", bg: "bg-blue-100", dot: "bg-blue-500" },
  discontinued: { label: "Discontinued", color: "text-slate-600", bg: "bg-slate-100", dot: "bg-slate-400" },
  salvaged: { label: "Salvaged", color: "text-purple-700", bg: "bg-purple-100", dot: "bg-purple-500" },
};

export const VALUE_TYPES = [
  { value: "actual", label: "Actual Cost" },
  { value: "estimated", label: "Estimated Cost" },
  { value: "verified", label: "Verified Cost" },
];

export const VALUE_TYPE_BADGE = {
  actual: { label: "Actual", color: "text-green-700", bg: "bg-green-50 border-green-200" },
  estimated: { label: "Estimated", color: "text-amber-700", bg: "bg-amber-50 border-amber-200" },
  verified: { label: "Verified", color: "text-blue-700", bg: "bg-blue-50 border-blue-200" },
};

export const TRANSACTION_LABELS = {
  purchase_received: { label: "Purchase Received", color: "text-green-700", bg: "bg-green-100" },
  issued_to_unit: { label: "Issued to Unit", color: "text-blue-700", bg: "bg-blue-100" },
  returned_to_stock: { label: "Returned to Stock", color: "text-teal-700", bg: "bg-teal-100" },
  inventory_adjustment: { label: "Inventory Adjustment", color: "text-amber-700", bg: "bg-amber-100" },
  salvaged_part_added: { label: "Salvaged Part Added", color: "text-purple-700", bg: "bg-purple-100" },
  vendor_return: { label: "Vendor Return", color: "text-orange-700", bg: "bg-orange-100" },
  warranty_return: { label: "Warranty Return", color: "text-indigo-700", bg: "bg-indigo-100" },
  scrap: { label: "Scrap", color: "text-red-700", bg: "bg-red-100" },
  transfer_between_locations: { label: "Transfer", color: "text-slate-700", bg: "bg-slate-100" },
  opening_balance: { label: "Opening Balance", color: "text-slate-700", bg: "bg-slate-100" },
};

export const ADJUSTMENT_REASONS = [
  "Lost", "Damaged", "Found", "Count Correction", "Vendor Return",
  "Warranty Return", "Scrap", "Other",
];

export const formatCurrency = (n) =>
  `$${(Number(n) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-US", {
      month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit",
    });
  } catch {
    return iso;
  }
};
